// extracted by mini-css-extract-plugin
module.exports = {"caseContainer":"CaseContainer_caseContainer__iOy26","container":"CaseContainer_container__F4lSr"};